import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Toodet saab tellida pakiautomaati!

  <span style="color:#85c1dc;">**FI:**</span>
  Tuotteen voi tilata pakettiautomaattiin!

  <span style="color:#85c1dc;">**RU:**</span>
  Товар можно заказать в посылочный терминал!
*/
/* @__NO_SIDE_EFFECTS__ */
const m1858 = msg(
  mf`Toodet saab tellida pakiautomaati!`,
  mf`Tuotteen voi tilata pakettiautomaattiin!`,
  mf`Товар можно заказать в посылочный терминал!`,
)

export { m1858 as 'w.module.delivery_section.parcel_machine' }